module.exports = __webpack_public_path__ + "static/media/STABI REFERENCE 2 TURNTABLE.a6455dfa.png";